import React from 'react';

const StepContainer = ({ active, children }) => {
	if (active === false || active === null || active === undefined) return null;
	return <div>{children}</div>;
};

export default StepContainer;
